import React from 'react';
import styled from 'styled-components';
import { StaticImage } from 'gatsby-plugin-image';
import { useQueryParam } from 'use-query-params';
import { Card } from '@/components/card';
import { VSpace } from '@/components/spacing';
import { breakpoints } from '@/components/responsive';

export function NoDateMessage({
  loading,
  hasDataForAllAudiences,
}: {
  loading: boolean;
  hasDataForAllAudiences?: boolean;
}) {
  const [audience] = useQueryParam(`aud`);
  return (
    <>
      <VSpace value={3} />
      <DetailsCard>
        <Wrapper>
          <Smile loading={loading}>
            <StaticImage
              src="bulb.svg"
              alt="no_data"
              placeholder="none"
              loading="eager"
              formats={[`png`, `webp`]}
              height={70}
            />
          </Smile>
          <WaitingForData loading={loading}>
            {audience && hasDataForAllAudiences
              ? `No data available for selected audience`
              : `Waiting for data…`}
            <br />
            {audience && hasDataForAllAudiences ? (
              <>
                <VSpace />
                <span>
                  Try Viewing the report without filters to see all data
                </span>
                <br />
                <span>
                  make sure not to change the text for no filter selection
                </span>
              </>
            ) : (
              <span>experience just started, data will be shown soon</span>
            )}
          </WaitingForData>
        </Wrapper>
      </DetailsCard>
    </>
  );
}

const Wrapper = styled.div`
  padding: 8rem 0;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: 5rem 1fr;
  grid-gap: 2rem;
  ${breakpoints.down(`md`)} {
    padding: 2rem;
  }
`;

const Smile = styled.div`
  display: ${(p: { loading: boolean }) => (p.loading ? `none` : `flex`)};
  margin: 0 0 8px 0;
  padding: 0;
  justify-content: center;
  align-items: center;

  ${breakpoints.down(`md`)} {
    .gatsby-image-wrapper {
      transform: scale(0.7);
    }
  }
`;

const WaitingForData = styled.span`
  display: ${(p: { loading: boolean }) => (p.loading ? `none` : `auto`)};
  color: #a6afb8;
  font-size: 2rem;
  font-family: 'JetBrains Mono', serif;
  span {
    font-size: 1.5rem;
    font-weight: 500;
  }
  font-weight: 800;
  text-align: center;

  ${breakpoints.down(`md`)} {
    font-size: 1.6rem;
    span {
      font-size: 1.4rem;
    }
  }
`;

const DetailsCard = styled(Card)`
  && {
    cursor: default;
    display: grid;
    grid-row-gap: 2.5rem;
    padding: 3.5rem;
    border-radius: 2rem;

    ${breakpoints.down(`md`)} {
      width: 90%;
      margin: 0 auto;
      padding: 2rem;
    }
  }
`;
